import type { ZoneCrossing } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listTripCrossings } from '../trips.api';

export type TripCrossingsState = { status: 'loading' } | { status: 'ready'; crossings: ZoneCrossing[] } | { status: 'error' };

/** A trip's arrivals and departures, read when its row is opened rather than for every trip on the tab. A trip has a handful, so not paged. */
export function useTripCrossings(tripId: string): TripCrossingsState {
  const [loaded, setLoaded] = useState<{ tripId: string; state: TripCrossingsState } | null>(null);

  useEffect(() => {
    let cancelled = false;
    listTripCrossings(tripId)
      .then((crossings) => {
        if (!cancelled) setLoaded({ tripId, state: { status: 'ready', crossings } });
      })
      .catch(() => {
        if (!cancelled) setLoaded({ tripId, state: { status: 'error' } });
      });
    return () => {
      cancelled = true;
    };
  }, [tripId]);

  return loaded?.tripId === tripId ? loaded.state : { status: 'loading' };
}
